import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { listStoreCategories } from "../../Redux/Actions/CategoryActions";
import Loading from "../LoadingError/Loading";
import Message from "../LoadingError/Error";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "../../screens/styles/categories-section.css";

const CategoriesSection = ({ title = "Categorías" }) => {
  const dispatch = useDispatch();

  const categoryStoreList = useSelector((state) => state.categoryStoreList);
  const { loading, error, categories = [] } = categoryStoreList || {};

  useEffect(() => {
    dispatch(listStoreCategories());
  }, [dispatch]);

  if (loading) return <Loading />;
  if (error) return <Message variant="alert-danger">{error}</Message>;
  if (!categories.length) return null;

  return (
    <section className="categories-carousel-section">
      <div className="site-shell">
        <div className="site-shell-inner">
          <div className="categories-carousel-header">
            <h2 className="categories-carousel-title">{title}</h2>
          </div>

          <Swiper
            modules={[Navigation, Autoplay]}
            navigation
            loop={categories.length > 5}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            spaceBetween={16}
            breakpoints={{
              0: { slidesPerView: 1 },
              520: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
              1100: { slidesPerView: 4 },
              1400: { slidesPerView: 5 },
            }}
          >
            {categories.map((cat) => (
              <SwiperSlide key={cat._id}>
                <div className="category-shop-card">
                  <div className="category-border-card">
                    <Link to={`/categorias/${cat.slug}`}>
                      <div className="category-shop-back">
                        {cat.imageUrl ? (
                          <img src={cat.imageUrl} alt={cat.name} />
                        ) : (
                          <div className="category-placeholder-card">
                            {cat.name?.charAt(0)}
                          </div>
                        )}
                      </div>
                    </Link>

                    <div className="category-shop-text">
                      <p>
                        <Link to={`/categorias/${cat.slug}`}>
                          {cat.name}
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;